import React, { forwardRef, useRef, useEffect, useState } from 'react';
import Container from '../../components/Container';
import NumberInput from '../../components/NumberInput';
import { Modal, Button, Form } from 'react-bootstrap';
import OfferTableNonmetallic from './OfferTableNonmetallic';
import ClientInfoNonmetallic from './ClientInfoNonmetallic';
import Tooltip from './Tooltip';
import { useOfferStateNonmetallic } from './useOfferStateNonmetallic';
import { useOptions } from '../../OptionsContext';
import { useAnalogsData } from './AnalogsDataContext';
import DropdownTable from '../../components/DropdownTable';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { getWazzupChannelId } from '../../projectProducts/wazzupUtils';
import { useTooltip } from './useTooltip';
import PositionedModal from './PositionedModal';

// Подгоняет высоту textarea превью-сообщения под контент (до 60vh, дальше скролл).
const autoSizeMessageTextarea = (el) => {
  if (!el) return;
  el.style.height = 'auto';
  // Кап оставляет место под шапку и подвал модалки, чтобы скроллилось
  // только поле (а не поле + контейнер) и кнопки оставались видимыми.
  const maxH = Math.max(160, window.innerHeight - 380);
  el.style.height = `${Math.min(el.scrollHeight, maxH)}px`;
};

const OfferNonmetallic = forwardRef(({ selectedOffer, addressAndCoordinates, dealId, clientName, onModalOpen, onModalClose, data, deliveryMethod, setDeliveryMethod, setSelectedOffer, paymentMethod, nonmetallicDeliveryMethods, setNonmetallicDeliveryMethods, productsRef }, ref) => {
  const { options } = useOptions();
  const { analogsData } = useAnalogsData();
  const localRef = useRef(null);
  const tableContainerRef = useRef(null);
  const tooltipRef = useRef(null);

  const [showRequestModal, setShowRequestModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showWazzupModal, setShowWazzupModal] = useState(false);
  const [showWazzupResultModal, setShowWazzupResultModal] = useState(false);
  const [wazzupResult, setWazzupResult] = useState({ type: '', message: '' });

  // Состояния для модального окна сообщения
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [messageText, setMessageText] = useState('');
  const [currentOfferForMessage, setCurrentOfferForMessage] = useState(null);

  // Состояния для Telegram
  const [showTelegramModal, setShowTelegramModal] = useState(false);
  const [showTelegramResultModal, setShowTelegramResultModal] = useState(false);
  const [telegramResult, setTelegramResult] = useState({ type: '', message: '' });
  const [telegramProfileId, setTelegramProfileId] = useState(null);
  const [showMaxModal, setShowMaxModal] = useState(false);
  const [showMaxResultModal, setShowMaxResultModal] = useState(false);
  const [maxResult, setMaxResult] = useState({ type: '', message: '' });

  const [formData, setFormData] = useState({
    regionId: '',
    materialId: '',
    tagId: '',
    competitorPrice: '',
    comment: '',
  });
  const [formErrors, setFormErrors] = useState({});
  const [regionOptions, setRegionOptions] = useState([]);
  const [materialOptions, setMaterialOptions] = useState([]);
  const [tagOptions, setTagOptions] = useState([]);
  const [isLoadingOptions, setIsLoadingOptions] = useState(false);
  const [responsibleName, setResponsibleName] = useState('');
  const [responsiblePhone, setResponsiblePhone] = useState('');
  const [responsibleId, setResponsibleId] = useState(null);
  const [clientPhone, setClientPhone] = useState(null);
  const [currentOfferToSend, setCurrentOfferToSend] = useState(null);
  const [excludedCategories, setExcludedCategories] = useState([]);

  React.useImperativeHandle(ref, () => localRef.current);

  const BITRIX_WEBHOOK_URL = process.env.REACT_APP_ROOF_BITRIX_CRM_DEAL_PRODUCTSROWS_SET;

  const formatPriceForMessage = (number) => {
    const rounded = Math.ceil(Number(number));
    const formattedInteger = rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return formattedInteger;
  };

  const {
    activeOffers,
    localPrices,
    localDeliveryPrice,
    localSkidka,
    localSkidkaD,
    localGlobalSkidka,
    per,
    analogs,
    analogDeliveries,
    buttonStates,
    notification,
    tooltip,
    responseText,
    setTooltip,
    setNotification,
    handleMaterialPriceChange,
    handleSkidkaChange,
    handleDeliveryPriceChange,
    handleDeliveryUpdate,
    handleDeliveryMethodChange,
    handleSkidkaChangeDelivery,
    handleGlobalSkidkaChange,
    skidkaOrMarzha,
    handleButtonClick,
    handleFillBitrix,
    addMaterialFromTooltip,
    removeMaterial,
    materialDeliveryMethods,
    materialDeliveryData,
    handleMaterialDeliveryMethodChange,
    sandAnalogs,
    isLoadingAnalogs,
    findAnalogsForSand,
    handleSelectAnalog,
  } = useOfferStateNonmetallic(selectedOffer, addressAndCoordinates, dealId, ref, options, clientName, analogsData, deliveryMethod, setDeliveryMethod, setSelectedOffer, nonmetallicDeliveryMethods, setNonmetallicDeliveryMethods, productsRef, paymentMethod);

  // Инициализация useTooltip на верхнем уровне
  const { handleMouseEnter, handleMouseLeave } = useTooltip(setTooltip, tableContainerRef, options, formatPriceForMessage);


  useEffect(() => {
    const fetchResponsibleFromDeal = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_PATH_TO_BACKEND}/api/get-deal?dealId=${dealId}`,
          { credentials: "include" }
        );
        const result = await response.json();
        if (result.success) {
          const assignedById = result.data.ASSIGNED_BY_ID;
          const userResponse = await fetch(
            `${process.env.REACT_APP_PATH_TO_BACKEND}/api/get-user?userId=${assignedById}`,
            { credentials: "include" }
          );
          const userResult = await userResponse.json();
          if (userResult.success) {
            const responsible = `${userResult.data.NAME || ''} ${userResult.data.LAST_NAME || ''}`.trim();
            const workPhone = userResult.data.WORK_PHONE ? userResult.data.WORK_PHONE.replace(/\D/g, '') : '';
            setResponsibleName(responsible);
            setResponsiblePhone(workPhone);
            console.log("Ответственный (Нерудка):", responsible, "Телефон:", workPhone);
          } else {
            setNotification({ type: 'error', message: 'Ошибка при получении данных ответственного.' });
          }
        } else {
          setNotification({ type: 'error', message: 'Ошибка при получении данных сделки.' });
        }
      } catch (err) {
        console.error("Ошибка при получении данных менеджера:", err);
        setNotification({ type: 'error', message: 'Ошибка при получении данных менеджера.' });
      }
    };

    if (dealId) fetchResponsibleFromDeal();
  }, [dealId, setNotification]);

  useEffect(() => {
    const fetchDropdownOptions = async () => {
      setIsLoadingOptions(true);
      try {
        const response = await axios.get(`${BITRIX_WEBHOOK_URL}/mlt.logistics.tags.list`);
        console.log(response);

        if (response.data && response.request.status === 200) {
          const { regions, materials, tags } = response.data.result;

          setRegionOptions(regions.map(item => ({
            value: item.ID,
            label: item.NAME,
          })));

          setMaterialOptions(materials.map(item => ({
            value: item.ID,
            label: item.name,
          })));

          setTagOptions(tags.map(item => ({
            value: item.ID,
            label: item.NAME,
          })));
        } else {
          throw new Error('Не удалось загрузить данные из API');
        }
      } catch (error) {
        console.error('Ошибка при загрузке данных для выпадающих списков:', error);
        setNotification({
          type: 'error',
          message: 'Не удалось загрузить данные для формы. Попробуйте позже.',
        });
        setRegionOptions([
          { value: "СПБ", label: "СПБ" },
          { value: "ЛО", label: "ЛО" },
          { value: "МСК", label: "МСК" },
          { value: "КРД", label: "КРД" },
        ]);
        setMaterialOptions(selectedOffer?.materials?.map(material => ({
          value: material.name,
          label: material.name,
        })) || []);
        setTagOptions([
          { value: "Срочный", label: "Срочный" },
          { value: "Обычный", label: "Обычный" },
          { value: "Низкий приоритет", label: "Низкий приоритет" },
        ]);
      } finally {
        setIsLoadingOptions(false);
      }
    };

    fetchDropdownOptions();
  }, [selectedOffer, setNotification]);

  const isDataAvailable = (activeOffers.original && activeOffers.original.materials && activeOffers.original.materials.length > 0) ||
    (selectedOffer && selectedOffer.materials && selectedOffer.materials.length > 0 && selectedOffer.delivery);

  // Отладочный лог для isDataAvailable
  console.log('🔍 isDataAvailable check:', {
    selectedOfferCheck: selectedOffer && selectedOffer.materials && selectedOffer.materials.length > 0 && selectedOffer.delivery,
    selectedOfferMaterialsLength: selectedOffer?.materials?.length,
    activeOffersCheck: activeOffers.original && activeOffers.original.materials && activeOffers.original.materials.length > 0,
    activeOffersMaterialsLength: activeOffers.original?.materials?.length,
    finalResult: isDataAvailable
  });

  // Для нерудки отключаем кнопки аналогов, так как они не используются
  const shouldRenderButtons = false;

  const getLabelById = (options, id) => {
    const option = options.find(opt => opt.value === id);
    return option ? option.label : '';
  };

  const handleOpenRequestModal = () => {
    setShowRequestModal(true);
    if (onModalOpen) onModalOpen();
  };

  useEffect(() => {
    console.log(activeOffers.original)
  }, [activeOffers.original])

  useEffect(() => {
    if (activeOffers.original?.materials) {
      const excludedCategories = activeOffers.original.materials.map((material) => material.category)
      setExcludedCategories(excludedCategories)
    } else if (selectedOffer?.materials) {
      const excludedCategories = selectedOffer.materials.map((material) => material.category)
      setExcludedCategories(excludedCategories)
    }

    console.log(excludedCategories)
  }, [selectedOffer?.materials, selectedOffer?.production, activeOffers.original?.materials])

  const handleCloseRequestModal = () => {
    setShowRequestModal(false);
    setFormData({
      regionId: '',
      materialId: '',
      tagId: '',
      competitorPrice: '',
      comment: '',
    });
    setFormErrors({});
    if (onModalClose) onModalClose();
  };

  const handleCloseConfirmModal = () => {
    setShowConfirmModal(false);
  };

  const handleFormChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value,
    }));
    setFormErrors(prev => ({
      ...prev,
      [field.replace('Id', '')]: '',
    }));
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.regionId) errors.region = "Поле 'Регион' обязательно";
    if (!formData.materialId) errors.material = "Поле 'Материал' обязательно";
    if (!formData.tagId) errors.tag = "Поле 'Тег' обязательно";
    if (!formData.competitorPrice) errors.competitorPrice = "Поле 'Цена конкурентов' обязательно";
    return errors;
  };

  const handleSubmitRequest = () => {
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }
    setShowConfirmModal(true);
  };

  const handleConfirmSubmit = async () => {
    try {
      const payload = {
        regionId: formData.regionId,
        materialId: formData.materialId,
        tagId: formData.tagId,
        competitorPrice: formData.competitorPrice,
        comment: formData.comment,
        dealId: dealId,
        clientName: clientName,
      };

      console.log("Отправка запроса логисту в Bitrix (Нерудка):", payload);
      const BITRIX_SUBMIT_URL = `${BITRIX_WEBHOOK_URL}mlt.logistics.tasks.set`;

      const requestData = {
        DEAL_ID: parseInt(payload.dealId),
        TASKS: JSON.stringify([
          {
            tag: payload.tagId,
            price: payload.competitorPrice,
            comment: payload.comment,
          },
        ]),
      };

      try {
        const response = await axios.post(BITRIX_SUBMIT_URL, requestData, {
          headers: { 'Content-Type': 'application/json' },
        });
        console.log('Успешный ответ:', response.data);
      } catch (error) {
        console.error('Ошибка при отправке запроса:', error.response?.data || error.message);
      }

      setShowConfirmModal(false);
      setShowRequestModal(false);
      setNotification({ type: 'success', message: 'Запрос успешно отправлен логисту!' });
      setFormData({
        regionId: '',
        materialId: '',
        tagId: '',
        competitorPrice: '',
        comment: '',
      });
      if (onModalClose) onModalClose();
    } catch (error) {
      console.error("Ошибка при отправке запроса:", error);
      setShowConfirmModal(false);
      setShowRequestModal(false);
      setNotification({ type: 'error', message: 'Не удалось отправить запрос логисту.' });
      if (onModalClose) onModalClose();
    }
  };

  const sendToWazzup = (offerToSend) => {
    if (!offerToSend || !offerToSend.materials || offerToSend.materials.length === 0) {
      setNotification({ type: 'error', message: 'Нет данных для отправки в Wazzup.' });
      return;
    }
    setCurrentOfferToSend(offerToSend);
    setShowWazzupModal(true);
  };

  const handleWazzupConfirm = async () => {
    setShowWazzupModal(false);
    setIsLoadingOptions(true);

    try {
      let phone = clientPhone;
      if (!phone) {
        phone = await fetchClientContact(dealId);
        if (!phone) {
          throw new Error("Номер телефона клиента не найден");
        }
        setClientPhone(phone);
      }

      const channelId = await getWazzupChannelId(responsibleName);
      if (!channelId) {
        throw new Error(`Канал Wazzup не найден для менеджера ${responsibleName}`);
      }

      const offerToSend = currentOfferToSend;
      if (!offerToSend) {
        throw new Error("Нет данных для отправки в Wazzup.");
      }

      const totalSum = offerToSend.materials.reduce((sum, mat) => sum + (parseInt(mat.sum) || 0), 0) +
        (offerToSend.delivery && offerToSend.delivery.name !== 'Самовывоз' ? parseInt(offerToSend.delivery.totalCost) || 0 : 0);
      // Формируем информацию о доставке
      const deliveryText = offerToSend.delivery && offerToSend.delivery.name !== 'Самовывоз'
        ? `\n${offerToSend.delivery.name} ${offerToSend.delivery.numberOfTrips} шт по ${offerToSend.delivery.costPerTrip} руб. (${formatPriceForMessage(offerToSend.delivery.totalCost)} руб.)`
        : "";

      const messageText = `В продолжение нашего разговора стоимость запрашиваемых нерудных материалов:\n\n${offerToSend.materials.map(mat => `${mat.name} ${mat.quantity} ${mat.unit} по ${formatPriceForMessage(mat.pricePerOne)} руб. (${formatPriceForMessage(mat.sum)} руб.)`).join('\n')}${deliveryText}\n\nОбщая сумма: ${formatPriceForMessage(totalSum)} руб.\n\n_Ваш персональный менеджер_\n*${responsibleName}*\n${responsiblePhone || ''}`;
      const referenceId = uuidv4();

      const response = await fetch(`${process.env.REACT_APP_PATH_TO_BACKEND}/api/send-wazzup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          channelId,
          chatType: "whatsapp",
          chatId: phone,
          text: messageText,
          referenceId,
          meta: {},
        }),
        credentials: "include",
      });

      const result = await response.json();
      if (response.status === 200 && result.success) {
        console.log("Сообщение успешно отправлено в Wazzup (Нерудка):", result);
        setWazzupResult({ type: 'success', message: 'Товары успешно отправлены в Wazzup!' });
      } else {
        throw new Error(result.message || `Ошибка ${response.status}`);
      }
    } catch (err) {
      console.error("Ошибка при отправке в Wazzup:", err);
      setWazzupResult({ type: 'error', message: `Ошибка: ${err.message}` });
    } finally {
      setIsLoadingOptions(false);
      setShowWazzupResultModal(true);
    }
  };

  const handleCloseWazzupResultModal = () => {
    setShowWazzupResultModal(false);
    setWazzupResult({ type: '', message: '' });
    setCurrentOfferToSend(null);
  };

  // Функция для формирования и отображения сообщения
  const createMessage = (offerToSend) => {
    if (!offerToSend || !offerToSend.materials || offerToSend.materials.length === 0) {
      setNotification({ type: 'error', message: 'Нет данных для формирования сообщения.' });
      return;
    }
    setCurrentOfferForMessage(offerToSend);

    const totalSum = offerToSend.materials.reduce((sum, mat) => sum + (parseInt(mat.sum) || 0), 0) +
      (offerToSend.delivery && offerToSend.delivery.name !== 'Самовывоз' ? parseInt(offerToSend.delivery.totalCost) || 0 : 0);
    const deliveryText = offerToSend.delivery && offerToSend.delivery.name !== 'Самовывоз'
      ? `\n${offerToSend.delivery.name} ${offerToSend.delivery.numberOfTrips} шт по ${offerToSend.delivery.costPerTrip} руб. (${formatPriceForMessage(offerToSend.delivery.totalCost)} руб.)`
      : "";

    const text = `По заказу №${dealId} стоимость запрашиваемых материалов:\n\n${offerToSend.materials.map(mat => `${mat.name} ${mat.quantity} ${mat.unit} по ${formatPriceForMessage(mat.pricePerOne)} руб. (${formatPriceForMessage(mat.sum)} руб.)`).join('\n')}${deliveryText}\n\nОбщая сумма: ${formatPriceForMessage(totalSum)} руб.\n\nВаш персональный менеджер\n${responsibleName}\n${responsiblePhone || ''}`;

    setMessageText(text);
    setShowMessageModal(true);
  };

  // Функция для копирования текста в буфер обмена
  const copyMessageToClipboard = async () => {
    try {
      // Создаем временный textarea для копирования (fallback для битрикса)
      const textArea = document.createElement('textarea');
      textArea.value = messageText;
      textArea.style.position = 'fixed';
      textArea.style.left = '-9999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      const successful = document.execCommand('copy');
      document.body.removeChild(textArea);

      if (successful) {
        const { toast } = await import('react-toastify');
        toast.success('Сообщение скопировано в буфер обмена!', { autoClose: 3000 });
      } else {
        throw new Error('Copy command failed');
      }
    } catch (err) {
      // Пробуем новый API как запасной вариант
      try {
        await navigator.clipboard.writeText(messageText);
        const { toast } = await import('react-toastify');
        toast.success('Сообщение скопирована в буфер обмена!', { autoClose: 3000 });
      } catch (clipboardErr) {
        const { toast } = await import('react-toastify');
        toast.error('Не удалось скопировать сообщение. Разрешите доступ к буферу обмена в браузере.', { autoClose: 5000 });
      }
    }
  };

  const handleMaxConfirmClipboard = async () => {
    setShowMessageModal(false);
    setIsLoadingOptions(true);

    try {
      let phone = clientPhone;
      if (!phone) {
        phone = await fetchClientContact(dealId);
        if (!phone) throw new Error("Номер телефона клиента не найден");
        setClientPhone(phone);
      }

      if (!responsibleId) throw new Error("Не удалось определить ответственного");

      const userResponse = await fetch(
        `${process.env.REACT_APP_PATH_TO_BACKEND}/api/get-user?userId=${responsibleId}`,
        { credentials: "include" }
      );
      const userResult = await userResponse.json();
      const profileId = userResult.success ? userResult.data.UF_TWITTER : null;
      if (!profileId) throw new Error("Для вашего аккаунта MAX не настроен");

      const checkResponse = await fetch(
        `${process.env.REACT_APP_PATH_TO_BACKEND}/api/check-max-registration?phone=${encodeURIComponent(phone)}&profileId=${encodeURIComponent(profileId)}`,
        { credentials: "include" }
      );
      const checkResult = await checkResponse.json();
      if (!checkResponse.ok || !checkResult.success) {
        throw new Error(checkResult.message || `Ошибка проверки MAX: ${checkResponse.status}`);
      }
      if (!checkResult.hasMax) throw new Error('Клиент не найден в MAX, либо номер не зарегистрирован');

      const response = await fetch(`${process.env.REACT_APP_PATH_TO_BACKEND}/api/send-max`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: "include",
        body: JSON.stringify({ phone, body: messageText, profileId, meta: { dealId } })
      });

      const result = await response.json();
      if (response.status === 200 && result.success) {
        setMaxResult({ type: 'success', message: 'Товары успешно отправлены в MAX!' });
      } else {
        throw new Error(result.message || `Ошибка ${response.status}`);
      }
    } catch (err) {
      console.error("Ошибка при отправке в MAX:", err);
      setMaxResult({ type: 'error', message: `Ошибка: ${err.message}` });
    } finally {
      setIsLoadingOptions(false);
      setShowMaxResultModal(true);
    }
  };

  // Функции для работы с Telegram
  const sendToTelegram = async (offerToSend) => {
    if (!offerToSend || !offerToSend.materials || offerToSend.materials.length === 0) {
      setNotification({ type: 'error', message: 'Нет данных для отправки в Telegram.' });
      return;
    }

    try {
      // Получаем данные пользователя для получения Profile ID
      const response = await fetch(
        `${process.env.REACT_APP_PATH_TO_BACKEND}/api/get-user?userId=${responsibleId}`,
        { credentials: "include" }
      );
      const result = await response.json();

      if (result.success && result.data && result.data.UF_WEB_SITES) {
        const profileId = result.data.UF_WEB_SITES;
        setTelegramProfileId(profileId);
        window.telegramProfileId = profileId;
        setCurrentOfferToSend(offerToSend);
        setShowTelegramModal(true);
      } else {
        setNotification({
          type: 'error',
          message: 'Для вашего отдела пока данная функция недоступна'
        });
      }
    } catch (error) {
      console.error('Ошибка при получении Profile ID:', error);
      setNotification({ type: 'error', message: 'Ошибка при получении Profile ID' });
    }
  };

  const handleTelegramConfirm = async () => {
    setShowTelegramModal(false);
    setIsLoadingOptions(true);

    try {
      let phone = clientPhone;
      if (!phone) {
        phone = await fetchClientContact(dealId);
        if (!phone) {
          throw new Error("Номер телефона клиента не найден");
        }
        setClientPhone(phone);
      }

      const profileId = telegramProfileId;
      if (!profileId) {
        throw new Error("Profile ID не найден. Попробуйте снова.");
      }

      const offerToSend = currentOfferToSend;
      if (!offerToSend) {
        throw new Error("Нет данных для отправки в Telegram.");
      }

      const totalSum = offerToSend.materials.reduce((sum, mat) => sum + (parseInt(mat.sum) || 0), 0) +
        (offerToSend.delivery && offerToSend.delivery.name !== 'Самовывоз' ? parseInt(offerToSend.delivery.totalCost) || 0 : 0);

      // Формируем информацию о доставке
      const deliveryText = offerToSend.delivery && offerToSend.delivery.name !== 'Самовывоз'
        ? `\n${offerToSend.delivery.name} ${offerToSend.delivery.numberOfTrips} шт по ${offerToSend.delivery.costPerTrip} руб. (${formatPriceForMessage(offerToSend.delivery.totalCost)} руб.)`
        : "";

      // Формируем текст сообщения с HTML разметкой
      const messageText = `По заказу №${dealId} стоимость запрашиваемых нерудных материалов:\n\n${offerToSend.materials.map(mat => `${mat.name} ${mat.quantity} ${mat.unit} по ${formatPriceForMessage(mat.pricePerOne)} руб. (${formatPriceForMessage(mat.sum)} руб.)`).join('\n')}${deliveryText}\n\nОбщая сумма: ${formatPriceForMessage(totalSum)} руб.\n\n<i>Ваш персональный менеджер</i>\n<b>${responsibleName}</b>\n${responsiblePhone || ''}`;

      const response = await fetch(`${process.env.REACT_APP_PATH_TO_BACKEND}/api/send-telegram?profile_id=${profileId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: "include",
        body: JSON.stringify({
          phone: phone,
          body: messageText,
          meta: {
            dealId: dealId
          }
        })
      });

      const result = await response.json();
      if (response.status === 200 && result.success) {
        console.log("Сообщение успешно отправлено в Telegram:", result);
        setTelegramResult({ type: 'success', message: 'Товары успешно отправлены в Telegram!' });
      } else {
        throw new Error(result.message || `Ошибка ${response.status}`);
      }
    } catch (err) {
      console.error("Ошибка при отправке в Telegram:", err);
      setTelegramResult({ type: 'error', message: `Ошибка: ${err.message}` });
    } finally {
      setIsLoadingOptions(false);
      setShowTelegramResultModal(true);
    }
  };

  const handleCloseTelegramModal = () => {
    setShowTelegramModal(false);
    setShowTelegramResultModal(false);
    setTelegramResult({ type: '', message: '' });
    setTelegramProfileId(null);
    window.telegramProfileId = null;
    setCurrentOfferToSend(null);
  };

  const sendToMax = (offerToSend) => {
    if (!offerToSend || !offerToSend.materials || offerToSend.materials.length === 0) {
      setNotification({ type: 'error', message: 'Нет данных для отправки в MAX.' });
      return;
    }
    setCurrentOfferToSend(offerToSend);
    setShowMaxModal(true);
  };

  const handleMaxConfirm = async () => {
    setShowMaxModal(false);
    setIsLoadingOptions(true);

    try {
      let phone = clientPhone;
      if (!phone) {
        phone = await fetchClientContact(dealId);
        if (!phone) throw new Error("Номер телефона клиента не найден");
        setClientPhone(phone);
      }

      if (!responsibleId) throw new Error("Не удалось определить ответственного");

      const userResponse = await fetch(
        `${process.env.REACT_APP_PATH_TO_BACKEND}/api/get-user?userId=${responsibleId}`,
        { credentials: "include" }
      );
      const userResult = await userResponse.json();
      const profileId = userResult.success ? userResult.data.UF_TWITTER : null;
      if (!profileId) throw new Error("Для вашего аккаунта MAX не настроен");

      const checkResponse = await fetch(
        `${process.env.REACT_APP_PATH_TO_BACKEND}/api/check-max-registration?phone=${encodeURIComponent(phone)}&profileId=${encodeURIComponent(profileId)}`,
        { credentials: "include" }
      );
      const checkResult = await checkResponse.json();
      if (!checkResponse.ok || !checkResult.success) {
        throw new Error(checkResult.message || `Ошибка проверки MAX: ${checkResponse.status}`);
      }
      if (!checkResult.hasMax) throw new Error('Клиент не найден в MAX, либо номер не зарегистрирован');

      const offerToSend = currentOfferToSend;
      if (!offerToSend) throw new Error("Нет данных для отправки в MAX.");

      const totalSum = offerToSend.materials.reduce((sum, mat) => sum + (parseInt(mat.sum) || 0), 0) +
        (offerToSend.delivery && offerToSend.delivery.name !== 'Самовывоз' ? parseInt(offerToSend.delivery.totalCost) || 0 : 0);

      const deliveryText = offerToSend.delivery && offerToSend.delivery.name !== 'Самовывоз'
        ? `\n${offerToSend.delivery.name} ${offerToSend.delivery.numberOfTrips} шт по ${offerToSend.delivery.costPerTrip} руб. (${totalSum} руб.)`
        : "";

      const messageText = `По заказу №${dealId} стоимость запрашиваемых материалов:\n\n${offerToSend.materials.map(mat => `${mat.name} ${mat.quantity} ${mat.unit} по ${mat.pricePerOne} руб. (${mat.sum} руб.)`).join('\n')}${deliveryText}\n\nОбщая сумма: ${totalSum} руб.\n\n<i>Ваш персональный менеджер</i>\n<b>${responsibleName}</b>\n${responsiblePhone || ''}`;

      const response = await fetch(`${process.env.REACT_APP_PATH_TO_BACKEND}/api/send-max`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: "include",
        body: JSON.stringify({ phone, body: messageText, profileId, meta: { dealId } })
      });

      const result = await response.json();
      if (response.status === 200 && result.success) {
        setMaxResult({ type: 'success', message: 'Товары успешно отправлены в MAX!' });
      } else {
        throw new Error(result.message || `Ошибка ${response.status}`);
      }
    } catch (err) {
      console.error("Ошибка при отправке в MAX:", err);
      setMaxResult({ type: 'error', message: `Ошибка: ${err.message}` });
    } finally {
      setIsLoadingOptions(false);
      setShowMaxResultModal(true);
    }
  };

  const handleCloseMaxModal = () => {
    setShowMaxModal(false);
    setShowMaxResultModal(false);
    setMaxResult({ type: '', message: '' });
    setCurrentOfferToSend(null);
  };

  const fetchClientContact = async (dealId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_PATH_TO_BACKEND}/api/get-deal?dealId=${dealId}`,
        { credentials: "include" }
      );
      const result = await response.json();
      if (result.success) {
        const contactId = result.data.CONTACT_ID;
        if (!contactId) {
          console.warn(`Контакт не привязан к сделке ${dealId}`);
          return null;
        }
        const contactResponse = await fetch(
          `${process.env.REACT_APP_PATH_TO_BACKEND}/api/get-contact?contactId=${contactId}`,
          { credentials: "include" }
        );
        const contactResult = await contactResponse.json();
        if (contactResult.success) {
          const phone = contactResult.data.PHONE?.[0]?.VALUE;
          return phone ? phone.replace(/\D/g, '').startsWith('+') ? phone : `+${phone.replace(/\D/g, '')}` : null;
        }
        throw new Error("Не удалось получить данные контакта");
      }
      throw new Error("Не удалось получить данные сделки");
    } catch (err) {
      console.error("Ошибка при получении контакта клиента:", err);
      return null;
    }
  };

  return isDataAvailable ? (
    <>
      <style jsx global>{`
        .custom-logist-modal .modal-dialog { max-width: 600px; }
        .custom-logist-modal .modal-content { border-radius: 15px; padding: 20px; background-color: #fff; border: none; box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1); }
        .custom-logist-modal .modal-title { font-size: 24px; font-weight: bold; color: #333; margin-bottom: 20px; }
        .custom-logist-modal .form-label { font-size: 16px; font-weight: 500; color: #555; margin-bottom: 5px; }
        .custom-logist-modal .form-group { margin-bottom: 20px; }
        .custom-logist-modal .narrow-container { background-color: #f8f9fa; padding: 15px; border-radius: 10px; margin: 20px 0; }
        .custom-logist-modal .textarea-field { width: 100%; min-height: 80px; padding: 10px; border: 1px solid #ddd; border-radius: 5px; font-size: 14px; resize: vertical; }
        .custom-logist-modal .error-text { color: #dc3545; font-size: 12px; margin-top: 5px; }
        .custom-logist-modal .modal-footer { border-top: none; justify-content: center; gap: 10px; }
        .custom-logist-modal .btn-cancel { background-color: #6c757d; color: #fff; border: none; border-radius: 25px; padding: 10px 30px; font-size: 16px; font-weight: 500; cursor: pointer; transition: background-color 0.3s ease; }
        .custom-logist-modal .btn-cancel:hover { background-color: #5a6268; }
        .custom-logist-modal .btn-submit { background-color: #007bff; color: #fff; border: none; border-radius: 25px; padding: 10px 30px; font-size: 16px; font-weight: 500; cursor: pointer; transition: background-color 0.3s ease; }
        .custom-logist-modal .btn-submit:hover { background-color: #0056b3; }
        .custom-confirm-modal .modal-dialog { max-width: 400px; }
        .custom-confirm-modal .modal-content { border-radius: 15px; padding: 20px; background-color: #fff; border: none; box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1); text-align: center; }
        .custom-confirm-modal .modal-body { font-size: 18px; color: #333; margin-bottom: 20px; }
        .custom-wazzup-modal .modal-dialog { max-width: 400px; }
        .custom-wazzup-modal .modal-content { border-radius: 15px; padding: 20px; background-color: #fff; border: none; box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1); text-align: center; }
        .custom-wazzup-modal .modal-body { font-size: 18px; color: #333; margin-bottom: 20px; }
        .custom-wazzup-result-modal .modal-dialog { max-width: 400px; }
        .custom-wazzup-result-modal .modal-content { border-radius: 15px; padding: 20px; background-color: #fff; border: none; box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1); text-align: center; }
        .custom-wazzup-result-modal .modal-header { border-bottom: none; }
        .custom-wazzup-result-modal .modal-body { font-size: 18px; color: #333; margin-bottom: 20px; }
        .custom-wazzup-result-modal .modal-footer { border-top: none; }
      `}</style>
      <section className="rd-section rd-kp-section" ref={localRef}>
        <div className="rd-sec-head">
          <h5>Коммерческое предложение</h5>
        </div>

        {(() => {
          const uniqueSources = [...new Set(selectedOffer.materials.map(m => m.source).filter(Boolean))];
          return (
            <div className="rd-kp-head">
              <div className="rd-kp-head__prod">
                {/* Выбранное производство */}
                <b>{selectedOffer.production}</b>
                {/* {uniqueSources.length === 1 && `Источник: ${uniqueSources[0]}`} */}
              </div>
              <div className="rd-kp-head__discount">
                <span
                  onClick={skidkaOrMarzha}
                  style={{ textDecoration: 'underline', cursor: 'pointer' }}
                  title="Переключить: скидка / маржа"
                >
                  Общая {per.text.toLowerCase()}
                </span>
                <NumberInput
                  value={localGlobalSkidka || ''}
                  onChange={(value) => handleGlobalSkidkaChange(value, 'original')}
                />
                <span>%</span>
              </div>
            </div>
          );
        })()}

        {activeOffers.original && (
          <OfferTableNonmetallic
            offer={activeOffers.original}
            offerType="original"
            activeOffers={activeOffers}
            selectedOffer={selectedOffer}
            localPrices={localPrices}
            localDeliveryPrice={localDeliveryPrice}
            localSkidka={localSkidka}
            localSkidkaD={localSkidkaD}
            localGlobalSkidka={localGlobalSkidka}
            per={per}
            tableContainerRef={tableContainerRef}
            onMaterialPriceChange={handleMaterialPriceChange}
            onSkidkaChange={handleSkidkaChange}
            onDeliveryPriceChange={handleDeliveryPriceChange}
            onDeliveryUpdate={handleDeliveryUpdate}
            onDeliveryMethodChange={handleDeliveryMethodChange}
            onSkidkaChangeDelivery={handleSkidkaChangeDelivery}
            onGlobalSkidkaChange={handleGlobalSkidkaChange}
            onSkidkaOrMarzha={skidkaOrMarzha}
            onFillBitrix={handleFillBitrix}
            onSendToTelegram={sendToTelegram}
            onSendToMax={sendToMax}
            onCreateMessage={createMessage}
            setTooltip={setTooltip}
            handleMouseEnter={handleMouseEnter}
            handleMouseLeave={handleMouseLeave}
            options={options}
            data={data}
            selectedProduction={selectedOffer.production}
            deliveryMethods={selectedOffer.deliveryMethods}
            onAddMaterial={addMaterialFromTooltip}
            onRemoveMaterial={removeMaterial}
            excludedCategories={excludedCategories}
            paymentMethod={paymentMethod}
            addressAndCoordinates={addressAndCoordinates}
            materialDeliveryMethods={materialDeliveryMethods}
            materialDeliveryData={materialDeliveryData}
            onMaterialDeliveryMethodChange={handleMaterialDeliveryMethodChange}
            productionInfo={selectedOffer.productionInfo}
            sandAnalogs={sandAnalogs}
            isLoadingAnalogs={isLoadingAnalogs}
            findAnalogsForSand={findAnalogsForSand}
            handleSelectAnalog={handleSelectAnalog}
          />
        )}

        {console.log('🔍 OfferNonmetallic передает в ClientInfoNonmetallic:', activeOffers.original)}
        {/* <ClientInfoNonmetallic selectedOffer={activeOffers.original} clientName={clientName} /> */}

        {/* Для нерудки не показываем кнопки аналогов */}
        {shouldRenderButtons ? null : null}

        <PositionedModal
          show={!!notification}
          onHide={() => {
            setNotification(null);
            if (onModalClose) onModalClose();
          }}
          targetElement={localRef.current}
        >
          <Modal.Header closeButton>
            <Modal.Title>{notification?.type === 'success' ? 'Успех' : 'Ошибка'}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {notification?.message.split('\n').map((line, index) => (
              <span key={index}>
                {line}
                {index < notification.message.split('\n').length - 1 && <br />}
              </span>
            ))}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={() => {
              setNotification(null);
              if (onModalClose) onModalClose();
            }}>ОК</Button>
          </Modal.Footer>
        </PositionedModal>

        <PositionedModal
          show={showRequestModal}
          onHide={handleCloseRequestModal}
          dialogClassName="custom-logist-modal"
          targetElement={localRef.current}
        >
          <Modal.Header closeButton>
            <Modal.Title>Запрос логисту (Нерудка)</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {isLoadingOptions ? (
              <div className="text-center">Загрузка данных...</div>
            ) : (
              <Form>
                <Form.Group className="form-group">
                  <Form.Label>Регион</Form.Label>
                  <DropdownTable
                    id="region"
                    options={regionOptions}
                    selectedValue={getLabelById(regionOptions, formData.regionId)}
                    onChange={(value) => handleFormChange('regionId', value)}
                  />
                  {formErrors.region && <div className="error-text">{formErrors.region}</div>}
                </Form.Group>

                <div className="narrow-container">
                  <Form.Group className="form-group">
                    <Form.Label>Материал</Form.Label>
                    <DropdownTable
                      id="material"
                      options={materialOptions}
                      selectedValue={getLabelById(materialOptions, formData.materialId)}
                      onChange={(value) => handleFormChange('materialId', value)}
                    />
                    {formErrors.material && <div className="error-text">{formErrors.material}</div>}
                  </Form.Group>

                  <Form.Group className="form-group">
                    <Form.Label>Тег</Form.Label>
                    <DropdownTable
                      id="tag"
                      options={tagOptions}
                      selectedValue={getLabelById(tagOptions, formData.tagId)}
                      onChange={(value) => handleFormChange('tagId', value)}
                    />
                    {formErrors.tag && <div className="error-text">{formErrors.tag}</div>}
                  </Form.Group>

                  <Form.Group className="form-group">
                    <Form.Label>Цена конкурентов</Form.Label>
                    <textarea
                      className="textarea-field"
                      value={formData.competitorPrice}
                      onChange={(e) => handleFormChange('competitorPrice', e.target.value)}
                    />
                    {formErrors.competitorPrice && <div className="error-text">{formErrors.competitorPrice}</div>}
                  </Form.Group>

                  <Form.Group className="form-group">
                    <Form.Label>Комментарий</Form.Label>
                    <textarea
                      className="textarea-field"
                      value={formData.comment}
                      onChange={(e) => handleFormChange('comment', e.target.value)}
                    />
                  </Form.Group>
                </div>
              </Form>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button className="btn-cancel" onClick={handleCloseRequestModal}>
              Отмена
            </Button>
            <Button
              className="btn-submit"
              onClick={handleSubmitRequest}
              disabled={isLoadingOptions}
            >
              Отправить
            </Button>
          </Modal.Footer>
        </PositionedModal>

        <PositionedModal
          show={showConfirmModal}
          onHide={handleCloseConfirmModal}
          dialogClassName="custom-confirm-modal"
          targetElement={localRef.current}
        >
          <Modal.Body>
            Товары добавятся в сделку. Запрос отправится логисту.
          </Modal.Body>
          <Modal.Footer>
            <Button className="btn-cancel" onClick={handleCloseConfirmModal}>
              Отмена
            </Button>
            <Button className="btn-submit" onClick={handleConfirmSubmit}>
              ОК
            </Button>
          </Modal.Footer>
        </PositionedModal>

        <PositionedModal
          show={showWazzupModal}
          onHide={() => setShowWazzupModal(false)}
          dialogClassName="custom-wazzup-modal"
          targetElement={localRef.current}
        >
          <Modal.Body>
            Сейчас товары будут отправлены в Wazzup.
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowWazzupModal(false)}>
              Отмена
            </Button>
            <Button variant="success" onClick={handleWazzupConfirm}>
              Отправить
            </Button>
          </Modal.Footer>
        </PositionedModal>

        <PositionedModal
          show={showWazzupResultModal}
          onHide={handleCloseWazzupResultModal}
          dialogClassName="custom-wazzup-result-modal"
          targetElement={localRef.current}
        >
          <Modal.Header closeButton>
            <Modal.Title>{wazzupResult.type === 'success' ? 'Успех' : 'Ошибка'}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {wazzupResult.message}
          </Modal.Body>
          <Modal.Footer>
            <Button
              className={wazzupResult.type === 'success' ? 'btn-success' : 'btn-danger'}
              onClick={handleCloseWazzupResultModal}
            >
              ОК
            </Button>
          </Modal.Footer>
        </PositionedModal>

        {/* Модальное окно для формирования сообщения */}
        <Modal show={showMessageModal} onHide={() => setShowMessageModal(false)} centered size="lg">
          <Modal.Header>
            <Modal.Title>Сформированное сообщение</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="rd-msg-hint">Можно отредактировать перед копированием</div>
            <textarea
              ref={autoSizeMessageTextarea}
              className="rd-msg-textarea"
              rows={12}
              value={messageText}
              onChange={(e) => { setMessageText(e.target.value); autoSizeMessageTextarea(e.target); }}
            />
          </Modal.Body>
          <Modal.Footer className="modal-footer-split">
            <Button className="btn-max btn-max-icon" onClick={handleMaxConfirmClipboard} title="Отправить в MAX" aria-label="Отправить в MAX">
              <img src="https://maxicons.ru/icons/Max_logo_black.svg" alt="MAX" width={24} height={24} />
            </Button>
            <div className="modal-footer-actions">
              <Button variant="secondary" onClick={() => setShowMessageModal(false)}>
                Закрыть
              </Button>
              <Button variant="primary" onClick={copyMessageToClipboard}>
                Копировать в буфер обмена
              </Button>
            </div>
          </Modal.Footer>
        </Modal>

        {/* Модалки для Telegram */}
        <PositionedModal
          show={showTelegramModal}
          onHide={() => setShowTelegramModal(false)}
          dialogClassName="custom-telegram-modal"
          targetElement={localRef.current}
        >
          <Modal.Body>
            Сейчас товары будут отправлены в Telegram.
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowTelegramModal(false)}>
              Отмена
            </Button>
            <Button variant="success" onClick={handleTelegramConfirm}>
              Отправить
            </Button>
          </Modal.Footer>
        </PositionedModal>

        <PositionedModal
          show={showTelegramResultModal}
          onHide={handleCloseTelegramModal}
          dialogClassName="custom-telegram-result-modal"
          targetElement={localRef.current}
        >
          <Modal.Header closeButton>
            <Modal.Title>{telegramResult.type === 'success' ? 'Успех' : 'Ошибка'}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {telegramResult.message}
          </Modal.Body>
          <Modal.Footer>
            <Button
              className={telegramResult.type === 'success' ? 'btn-success' : 'btn-danger'}
              onClick={handleCloseTelegramModal}
            >
              ОК
            </Button>
          </Modal.Footer>
        </PositionedModal>

        {/* Модалки для MAX */}
        <PositionedModal
          show={showMaxModal}
          onHide={() => setShowMaxModal(false)}
          dialogClassName="custom-max-modal"
          targetElement={localRef.current}
        >
          <Modal.Body>
            Сейчас товары будут отправлены в MAX.
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowMaxModal(false)}>
              Отмена
            </Button>
            <Button className="btn-max" onClick={handleMaxConfirm}>
              Отправить
            </Button>
          </Modal.Footer>
        </PositionedModal>

        <PositionedModal
          show={showMaxResultModal}
          onHide={handleCloseMaxModal}
          dialogClassName="custom-max-result-modal"
          targetElement={localRef.current}
        >
          <Modal.Header closeButton>
            <Modal.Title>{maxResult.type === 'success' ? 'Успех' : 'Ошибка'}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {maxResult.message}
          </Modal.Body>
          <Modal.Footer>
            <Button
              className={maxResult.type === 'success' ? 'btn-max' : 'btn-danger'}
              onClick={handleCloseMaxModal}
            >
              ОК
            </Button>
          </Modal.Footer>
        </PositionedModal>

        <Tooltip tooltip={tooltip} tooltipRef={tooltipRef} />
      </section>
    </>
  ) : null;
});

export default OfferNonmetallic;
